<template>
    <NavItem v-if="projects.length > 1" class="dropdown-user dropdown">
        <NavItemLink class="d-flex align-items-center dropdown-toggle legitRipple" :is-dropdown-toggle="true">
            <span class="text-truncate d-inline-block" style="max-width: 200px" :title="currentProjectName">{{ currentProjectName }}</span>
        </NavItemLink>
        <DropDownMenu class="dropdown-menu-right">
            <TextDropDownMenuItem
                v-for="projectUser in projects"
                :key="projectUser.project.uuid"
                :class="{ active: isCurrentProject(projectUser.project) }"
                @click="navigateToProject(projectUser.project)"
            >
                <span class="text-truncate d-inline-block" style="max-width: 200px" :title="projectUser.project.name">{{ projectUser.project.name }}</span>
            </TextDropDownMenuItem>
        </DropDownMenu>
    </NavItem>
</template>
<script>
import NavItem from '../../../../components/navbar/AppNavItem.vue'
import NavItemLink from '../../../../components/navbar/AppNavItemLink.vue'
import DropDownMenu from '../../../../components/dropdown/AppDropDownMenu.vue'
import TextDropDownMenuItem from '../../../../components/dropdown/TextDropDownMenuItem.vue'
import {httpClient} from "../../../../../services/HttpClient";
import {generateUrl} from "../../../../../utils";
import {mapGetters} from "vuex";

export default {
    name: 'ProjectsTab',
    components: {
        NavItem,
        NavItemLink,
        DropDownMenu,
        TextDropDownMenuItem
    },
    data() {
        return {
            projects: [],
        }
    },
    computed: {
        ...mapGetters('route', ['project']),
        currentProjectName() {
            let currentProjectUser = this.projects.find(projectUser => this.isCurrentProject(projectUser.project))

            return currentProjectUser ? currentProjectUser.project.name : ''
        }
    },
    methods: {
        generateUrl,
        fetchProjects() {
            httpClient.get('/my/projects', {
                limit: 50
            }).then((response) => {
                this.projects = response.data.data
            })
        },
        isCurrentProject(project) {
            if (this.project) {
                return project.uuid === this.project.uuid
            }

            return window.location.hostname.split('.')[0] === project.alias
        },
        navigateToProject(project) {
            window.location.href = this.generateUrl(`app/projects/${project.uuid}/dashboard`, project.alias)
        }
    },
    mounted() {
        this.fetchProjects()
    }
}
</script>
